export default "__VITE_ASSET__b46531b7__"